import { api } from '@/lib/api/axios';
import type {
  CreateWalkInQueueRequestDto,
  CreateWalkInQueueResponseDto,
  ProfileWalkInsResponse,
} from '@/types/dto/walk-in.dto';

export const WalkInService = {
  create: async (payload: CreateWalkInQueueRequestDto): Promise<CreateWalkInQueueResponseDto> => {
    const { data } = await api.post<CreateWalkInQueueResponseDto>('/walk-ins', payload);

    return data;
  },
  list: async (): Promise<ProfileWalkInsResponse> => {
    const { data } = await api.get<ProfileWalkInsResponse>('/walk-ins');

    return data;
  },
  cancel: async (walkInId: string): Promise<void> => {
    await api.patch(`/walk-ins/${walkInId}/cancel`);
  },
};
